import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Input, Table, Button, Spin, Popconfirm, Row, Col, Pagination } from 'antd';
import { connect } from 'react-redux';
import { getList, createShowAddAction, createShowEditAction, delUser, getDetail } from '../../actions/user';
import Add from '../sub-sider/user-add';
import Edit from '../sub-sider/user-edit';

const { Column } = Table;
const Search = Input.Search;

/**
 * 页面组件
 */

class userlist extends Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 1, // 分页页码
            pageSize: 10, // 分页大小
            name: '',
        };
        this.changePageSize = this.changePageSize.bind(this);
    }
    async changePageSize(pageNumber, pageSize) {
        await this.setState({
            ...this.state,
            page: pageNumber,
            pageSize: pageSize,
        });
        await this.props.getList(this.state);
    }

    componentWillMount() {
        this.props.getList(this.state);
    }

    async search(value) {
        try {
            const search = Object.assign(this.state, { name: value });
            await this.props.getList(search);
        } catch (err) {
            alert(err);
        }
    }

    async delUser(id, showid, status) {
        try {
            await this.props.delUser(id);
            await this.props.getList(this.state);
        } catch (err) {
            alert(err);
        }
    }
    render() {
        const { loading, userList, pageTotal, changeAddState, changeEditState, delUser, getDetail } = this.props;
        const right = {
            float: 'right',
        };
        return (
            <div>
                <Add page={this.state.page} pageSize={this.state.pageSize} />
                <Edit page={this.state.page} pageSize={this.state.pageSize} />
                <h2>用户列表</h2>
                <div className="searchRow">
                    <Search placeholder="请填写用户名" style={{ width: 200 }} onSearch={value => this.search(value)} />
                    <Button type="primary" style={{ marginLeft: '20px' }} onClick={() => changeAddState(true)}>
                        添加
                    </Button>
                </div>
                <Spin spinning={loading} tip="加载中">
                    <Table dataSource={userList} pagination={false} bordered>
                        <Column title="用户名" dataIndex="name" />
                        <Column title="创建时间" dataIndex="created" />
                        <Column title="权限组" dataIndex="role" />
                        <Column
                            title="操作"
                            dataIndex="action"
                            render={(text, record, index) => (
                                <span>
                                    <Popconfirm
                                        title="确定删除该条信息？"
                                        okText="确定删除"
                                        cancelText="取消删除"
                                        onConfirm={id => this.delUser(record._id)}>
                                        <a href="#">删除</a>
                                    </Popconfirm>
                                    <span className="ant-divider" />
                                    <a href="javascript:;" onClick={name => getDetail(record.name)}>
                                        帐号修改
                                    </a>
                                </span>
                            )}
                        />
                    </Table>
                </Spin>
                {pageTotal > 0 ? (
                    <Pagination
                        showQuickJumper
                        showSizeChanger
                        onChange={this.changePageSize}
                        onShowSizeChange={this.changePageSize}
                        className="ant-table-pagination"
                        pageSize={this.state.pageSize}
                        defaultPageSize={this.state.pageSize}
                        current={this.state.page}
                        total={pageTotal}
                    />
                ) : null}
            </div>
        );
    }
}
const mapStateToProps = state => ({
    loading: state.user.userpageState.loading,
    pageTotal: state.user.userpageState.pageTotal,
    userList: state.user.userList,
});

const mapDispatchToProps = dispatch => ({
    getList: params => dispatch(getList(params)),
    changeAddState: adding => dispatch(createShowAddAction(adding)),
    changeEditState: editing => dispatch(createShowEditAction(editing)),
    delUser: id => dispatch(delUser(id)),
    getDetail: name => dispatch(getDetail(name)),
});
export default connect(mapStateToProps, mapDispatchToProps)(userlist);



// WEBPACK FOOTER //
// ./components/sider/userlist.js